import { baseApi } from '@/shared/api/base-api';
import { normalizePro20Response } from '@/shared/api/pro20-transform';

/** Pro20 service link suggested as a WhatsApp CTA dynamic path. */
export interface CtaLinkUrl {
  type: string;
  name: string;
  url: string;
}

function readString(value: unknown): string {
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value).trim();
  }
  return '';
}

function asRecord(value: unknown): Record<string, unknown> | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  return value as Record<string, unknown>;
}

function normalizeCtaLinkUrls(data: unknown): CtaLinkUrl[] {
  const source = normalizePro20Response(data);
  const record = asRecord(source);
  const list = Array.isArray(source)
    ? source
    : (record?.data ?? record?.content);

  if (!Array.isArray(list)) {
    return [];
  }

  return list
    .map((entry) => asRecord(entry))
    .filter((row): row is Record<string, unknown> => Boolean(row))
    .map((row) => ({
      type: readString(row.type),
      name: readString(row.name),
      url: readString(row.url),
    }))
    .filter((row) => Boolean(row.url));
}

export const branchUtilityApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCtaLinkUrls: builder.query<CtaLinkUrl[], { branchCode: string }>({
      query: ({ branchCode }) => ({
        url: `/branch-utility/linkurls/${encodeURIComponent(branchCode)}`,
        method: 'GET' as const,
      }),
      transformResponse: (data: unknown) => normalizeCtaLinkUrls(data),
    }),
  }),
});

export const { useGetCtaLinkUrlsQuery } = branchUtilityApi;
